<template>
    <div class="services">
        <div class="services__title">{{$t('services.services')}}</div>
        <div class="services__box">
            <div class="services-items">
                <div  
                    v-for="item in services" 
                    :key="item.id"
                    class="service-item" 
                    :class="{'service-item_active': currentServiceId === item.id}"
                    @click="setActiveService(item)"
                > 
                    <img 
                        :src="item.icon" 
                        :alt="item.title"
                        class="service-item__icon"
                    >
                    <p>{{item.title}}</p>
                </div> 
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'services-list',
    props: {
        services: {
            required: true,
            type: Array
        },
        currentServiceId: {
            required: true,
            default: null
        }
    },
    data() {
        return { 
            prevServiceId: null,
            currentServiceSlug: null
        }
    },
    methods: { 
        setCurrentService({id, slug}) {
            this.prevServiceId = this.currentServiceId; 
            this.currentServiceSlug = slug; 
            this.$emit('setCurrentService', id);
        },
        setActiveService(item) {
            this.setCurrentService(item); 
            this.$emit('setOption', item.slug);
        },
    },
    created() { 
        this.setCurrentService(this.services[0])
    }
}
</script>